import React from "react"
import { useStore } from "../../teafuljs/store"
import { getTranslation } from "../../scripts/getTranslation"
import BibleEffectVideo from "./BibleEffectVideo"
import BibleProjectVideos from "./BibleProjectVideos"

const RecommendedResources = ({ showRR }) => {
  const language = useStore.language()[0]
  const translations = useStore.translations()[0]

  if (!showRR) return null;
  return (
    <div
      style={{
        margin: "10px 0",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <h2 style={{textDecoration: 'underline'}}>
        {getTranslation(translations, language, "UI", "recommended_resources")}
      </h2>
    </div>
  )
}

export default RecommendedResources